module.exports = __webpack_public_path__ + "media/living_room_loop.c7bf3e76.mp4";